import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#fff\" d=\"M0 .5h48v48H0z\"></path><path stroke=\"#475467\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10 11.667C10 9.642 11.567 8 13.5 8h21c1.933 0 3.5 1.642 3.5 3.667V41l-7-3.667L24 41l-7-3.667L10 41V11.667Z\"></path><g clip-path=\"url(#a)\"><path stroke=\"#475467\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M20.5 31.835a2.333 2.333 0 0 0 2.333 2.333h2.334a2.333 2.333 0 0 0 0-4.667h-2.334a2.333 2.333 0 0 1 0-4.666h2.334a2.333 2.333 0 0 1 2.333 2.333m-3.5-3.5v11.667\"></path></g><path stroke=\"#475467\" stroke-linecap=\"round\" stroke-width=\"3\" d=\"M15.5 13h17M15.5 18h11M31.5 18h1M15.5 23h1\"></path><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M17 22.5h14v14H17z\"></path></clipPath></defs>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }